import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { BEIGE_300, RhetorikFontFamily } from 'constants/styling/theme'
import { MUIButton } from 'components/common/MUIButton'

/**
 * @component
 * ErrorPage - Displays a generic error page when something goes wrong.
 *
 * NOTE: This component is used as a Sentry ErrorBoundary fallback in index.tsx,
 * which renders OUTSIDE the Router. Do not use useNavigate(), useLocation(), or
 * any other router-dependent hooks here — and do not render StatusPage (which
 * wraps PageTransition → useLocation) for the same reason. Use
 * window.location.href for navigation instead.
 *
 * @example
 * <ErrorPage />
 */
const ErrorPage: React.FC = () => {
  const { t } = useTranslation('errorpage')

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor={BEIGE_300}
    >
      <Stack direction="column" maxWidth="58rem" alignItems="center" textAlign="center" gap="3.6rem">

        <Typography variant="display-md" fontWeight={300} fontFamily={RhetorikFontFamily}>
          {t('title')}
        </Typography>

        <Typography variant="text-md">
          {t('text')}
        </Typography>

        <MUIButton size="lg" type="defaultPrimary" onClick={() => { window.location.href = '/' }}>
          <Typography variant="text-md" fontWeight={450}>
            {t('button')}
          </Typography>
        </MUIButton>

      </Stack>
    </Stack>
  )
}

export default ErrorPage
